import React from "react";
import { useMemo } from "react";
import { useTable } from "react-table";
import { format } from 'date-fns';



const Table = ({ employees, selectedEmployee, setSelectedEmployee, currentPage, itemsPerPage }) => {

  const columns = useMemo(() => [
    {
      Header: 'S.no',
      Cell: ({ row }) => (currentPage-1) * itemsPerPage + row.index + 1
    },
    {
      Header: "ID",
      accessor:"id",
    },
    {
      Header: "EMP_ID",
      accessor:"emp_id",
    },
    {
      Header: "Name",
      accessor:"name",
    },
    {
      Header: "Designation",
      accessor:"designation",
    },
    {
      Header: "Email",
      accessor:"email",
    },
    {
      Header: "Phone",
      accessor:"phone_no",
    },
    {
      Header: "DoJ",
      Cell: ({ row }) => {
        const date = new Date(row.original.doj);
        return format(date, 'EEE, dd MMM yyyy');
      },
      accessor: 'doj'
    },
    {
      Header: "Department",
      accessor:"department",
    },
    {
      Header: "Action",
      Cell :( {row} ) => (
          <input
            type="radio"
            name="employee_radio"
            value={row.original.id}
            checked={selectedEmployee === row.original.id}
            onChange={() => setSelectedEmployee(row.original.id)}
          />
      )
    },
  ], [currentPage, itemsPerPage, selectedEmployee, setSelectedEmployee]);

  const {
    getTableProps, 
    getTableBodyProps, 
    headerGroups, 
    rows, 
    prepareRow
  } = useTable({
    columns, 
    data:employees
  });

  // const selectedEmployeeData = employees.find(emp => emp.id === selectedEmployee);
  // console.log("Selected Employee Data:", selectedEmployeeData);


  return(
    <div className="App" style={{ overflowX: 'auto', maxWidth: '100%' }}>
      <div className="Container">
        <table {...getTableProps()} id="dataTable" >
          <thead> 
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <th {...column.getHeaderProps()} key={column.id}>
                    {column.render("Header")}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {rows.map((row) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()} key={row.id}>
                  {row.cells.map((cell) => (
                    <td {...cell.getCellProps()} key={cell.column.id}> 
                      {cell.render("Cell")}
                    </td>
                  ))}
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    </div>
  )
};
export default Table;